import { Modal, ModalBody } from 'reactstrap';
import { create } from 'zustand';

interface QRCodeModalState {
  isOpen: boolean;
  onQRCodeModalClose: () => void;
  onQRCodeModalOpen: (qr_code: string, msg?: string) => void;
  msg?: string;
  qr_code: string;
}
export const useQRCodeModalStore = create<QRCodeModalState>(set => ({
  isOpen: false,
  msg: '',
  qr_code: '',

  onQRCodeModalClose: () => {
    set({ isOpen: false });
  },
  onQRCodeModalOpen: (qr_code: string, msg?: string) => {
    set({ isOpen: true, qr_code, msg });
  },
}));
const QRCodeModal: React.FC = () => {
  const { isOpen, onQRCodeModalClose, msg, qr_code } = useQRCodeModalStore();
  return (
    <div>
      <Modal isOpen={isOpen} toggle={onQRCodeModalClose} size="sm">
        <ModalBody className="text-center p-0">
          <img src={qr_code} alt={msg || ''} className="w-100 h-100" />
          <div className="my-2 fs-16 ">{msg || ''}</div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default QRCodeModal;
